import Box from "@mui/material/Box";
import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ColorButton } from "../../features/home/styles/componentStyled";
import { Company } from "../../features/setups/types/setupTypes";
import { Employee } from "../../features/process/types/processTypes";

interface Props {
  selectedCompany: Company;
  selectedEmployee: Employee;
}
const ChooseCandidate = ({ selectedCompany, selectedEmployee }: Props) => {
  const theme = useTheme();
  const { t: tt } = useTranslation();
  console.log(selectedCompany);
  // const { selectedCompany } = useAppSelector(selectSetups);
  // const { selectedEmployee } = useAppSelector(selectProcesses);

  return (
    <Box
      sx={{
        position: "fixed",
        // left: theme.direction === "rtl" ? "10px" : "auto",
        // right: theme.direction === "ltr" ? "10px" : "auto",
        top: "5px",
        bottom: "auto",
        zIndex: "999",
        mx: 2,
      }}
    >
      {/* {selectedCompany &&
        selectedCompany.address &&
        selectedCompany.address.mobile &&
        selectedEmployee &&
        selectedEmployee._id && (
          <ColorButton
            target="_blank"
            href={`https://wa.me/${selectedCompany.address.mobile}?text=https://portal.ultramanpowercompany.com/app/cvp/${selectedEmployee._id}_${selectedEmployee.givenName}_${selectedEmployee.passportNumber}`}
            justifyItems="center"
            alignItems="center"
          >
            {" "}
            <img
              alt="Chat on WhatsApp"
              src="/Digital_Glyph_White.svg"
              width="50px"
              height="40px"
            />
            {tt("choose_candidate")}
          </ColorButton>
        )} */}
      {selectedEmployee && selectedEmployee._id && (
        <ColorButton
          target="_blank"
          href={`https://wa.me/?text=https://portal.ultramanpowercompany.com/app/cvp/${selectedEmployee._id}_${selectedEmployee.givenName}_${selectedEmployee.passportNumber}`}
          justifyItems="center"
          alignItems="center"
        >
          {" "}
          <img
            alt="Chat on WhatsApp"
            src="/Digital_Glyph_White.svg"
            width="50px"
            height="40px"
          />
          {tt("choose_candidate")}
        </ColorButton>
      )}
    </Box>
  );
};

export default ChooseCandidate;

// ?text=${window.location.href}
